import {
    AdminDashboardPage,
      DAllMealsPage,
      CreateMealPage,
      EditMealPage,
  
      EditReviewPage,

      EditCategoryPage,

      EditUserRolePage,

      DAllReviewsPage,
      DAllCategoryPge,
  
      CreateReviewPage,

      CreateCategoryPage,
      CreateFeaturedMealsPage,
      EditFeaturedMealsPage,
      DAllFeaturedMealsPage,
  


  } from "../pages/admindashboard";

export const AdminRouters = [
    { path: "/admin", element: <AdminDashboardPage /> },
    { path: "/EditMealPage/:id", element: <EditMealPage /> },
   
    { path: "/EditReviewPage/:id", element: <EditReviewPage /> },

    { path: "/EditCategoryPage/:id", element: <EditCategoryPage /> },

    { path: "/EditUserRolePage/:id", element: <EditUserRolePage /> },



    { path: "/DAllMealsPage", element: <DAllMealsPage /> },

    { path: "/DAllReviewsPage", element: <DAllReviewsPage /> },
    { path: "/DAllCategoriesPage", element: <DAllCategoryPge /> },



    { path: "/CreateMealPage", element: <CreateMealPage /> },
    { path: "/CreateReviewPage", element: <CreateReviewPage /> },
    { path: "/CreateCategoryPage", element: <CreateCategoryPage /> },
    {path: "/DAllFeaturedMealsPage", element: <DAllFeaturedMealsPage />},
    {path: "/CreateFeaturedMealsPage", element: <CreateFeaturedMealsPage />},
    {path: "/EditFeaturedMealsPage/:id", element: <EditFeaturedMealsPage />},


   
  ];